import { Link, usePage } from '@inertiajs/react'
import { LayoutDashboard, Building2, Users, ShieldAlert } from 'lucide-react'
import { cn } from '@/lib/utils'
import { LogoIcon } from '@/components/landing/Logo'

const navItems = [
  { href: '/admin', label: 'Overview', icon: LayoutDashboard },
  { href: '/admin/organizations', label: 'Organizations', icon: Building2 },
  { href: '/admin/users', label: 'Users', icon: Users },
]

export function AdminSidebar() {
  const { url } = usePage()

  return (
    <div className="flex h-full flex-col gap-2 p-4">
      {/* Brand row */}
      <Link
        href="/"
        className="flex items-center gap-2 px-2 py-3 font-heading text-[15px] font-semibold tracking-tight"
      >
        <LogoIcon />
        <span>KonexZero</span>
      </Link>

      {/* Super-admin badge — destructive surface, no hard separator */}
      <div className="surface-card mx-1 mt-1 mb-3 flex items-center gap-2 px-3 py-3">
        <ShieldAlert className="h-4 w-4 shrink-0 text-destructive" />
        <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-destructive">
          Super Admin
        </div>
      </div>

      <nav className="flex flex-col gap-1">
        {navItems.map(({ href, label, icon: Icon }) => {
          const isActive =
            href === '/admin' ? url === '/admin' : url.startsWith(href)
          return (
            <Link
              key={href}
              href={href}
              className={cn(
                'group relative flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-all',
                isActive ? 'text-foreground' : 'text-muted-foreground hover:text-foreground',
              )}
            >
              {isActive && (
                <span
                  aria-hidden
                  className="absolute inset-y-1 left-0 w-[3px] rounded-full"
                  style={{
                    background:
                      'linear-gradient(180deg, hsl(var(--destructive)) 0%, hsl(var(--brand-2)) 100%)',
                  }}
                />
              )}
              {isActive && (
                <span
                  aria-hidden
                  className="absolute inset-0 rounded-lg bg-foreground/[0.04]"
                />
              )}
              <Icon
                className={cn(
                  'relative h-4 w-4 shrink-0',
                  isActive ? 'text-foreground' : 'text-muted-foreground group-hover:text-foreground',
                )}
                strokeWidth={1.7}
              />
              <span className="relative">{label}</span>
            </Link>
          )
        })}
      </nav>
    </div>
  )
}
